import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelSegmentDrilldownController from 'lumen/controllers/hotel/segment-drilldown';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import getEnv from 'lumen/helpers/get-env';

interface HotelSegmentDrilldownSignature {
  Args: {
    controller: HotelSegmentDrilldownController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "menu.spider.segment-drilldown"))}}

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-segment-drilldown"
    @query={{@controller.iframeQPs}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<HotelSegmentDrilldownSignature>;
